var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.488,
    height: 35.62,
    viewBox: "0 0 39.488 35.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1081",
    "data-name": "Ret\\xE2ngulo 1081",
    width: 33.398,
    height: 27.927,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 7.228, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M33.4,2.343q-.545,2.534-1.09,5.068Q30.32,16.74,28.334,26.069a3.6,3.6,0,0,1-.39,1.1,1.392,1.392,0,0,1-1.661.7,2.8,2.8,0,0,1-1.024-.483c-2.374-1.743-4.752-3.48-7.118-5.233-.259-.192-.4-.168-.619.049-1.134,1.11-2.286,2.2-3.43,3.3a2.148,2.148,0,0,1-1.162.679c-.343.051-.4-.017-.379-.36q.157-2.113.3-4.227c.07-.986.14-1.973.2-2.96a.661.661,0,0,1,.263-.466q2.679-2.409,5.356-4.82L25.39,7.314q.9-.806,1.8-1.612a2.317,2.317,0,0,0,.207-.207c.079-.092.161-.195.084-.321a.308.308,0,0,0-.316-.127,1.678,1.678,0,0,0-.728.265Q22.373,7.858,18.314,10.4q-4.584,2.874-9.167,5.749a.76.76,0,0,1-.7.1Q4.831,15.113,1.207,13.99a2.25,2.25,0,0,1-.936-.509.745.745,0,0,1-.1-1.057,2.114,2.114,0,0,1,.865-.675c1.075-.5,2.2-.881,3.3-1.306q9.091-3.5,18.187-6.978Q26.772,1.837,31.015.209A2.252,2.252,0,0,1,32.156.016,1.474,1.474,0,0,1,33.4,1.233Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.01ca51c852a370705171bb988d709cba.svg";
export { ForwardRef as ReactComponent };